import axios from 'axios';

export const authService = {
    /** Abc */

    getAbcsService: (params, clientId) => axios.get(`/clinical/abc/${clientId}`, { auth: true, params: { ...params } }),

    getAbcByIdService: (abcId) => axios.get(`/clinical/abc/byId/${abcId}`, { auth: true }),

    createManualAbcService: (body) => axios.post(`/clinical/abc/manual`, body, { auth: true }),

    createAbcService: (body) => axios.post(`/clinical/abc`, body, { auth: true }),

    editAbcService: (id, body) => axios.patch(`/clinical/abc/${id}`, body, { auth: true }),

    deleteAbcService: (id) => axios.delete(`/clinical/abc/${id}`, { auth: true }),

    /** End */
};
